export default __webpack_public_path__ + "static/media/settings.fa1b6423.png";